import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const NotificationFilterV1 = ({
    showModal,
    setShowModal,
    allCategoryData,
    setAllCategoryData,
    loader,
    handleFilterSaveBtn
}) => {

    function handleInputChange(e, id) {
        const inputModifiedArr = allCategoryData?.map((item) => {
            if (item?.ID === id) {
                item.isChecked = e.target.checked
            }
            return item;
        })
        setAllCategoryData(inputModifiedArr);
    }

    function manuplateAllItems(status) {
        const allCheckedItems = allCategoryData?.map((item) => {
            item.isChecked = status
            return item;
        });
        setAllCategoryData(allCheckedItems);
    }

    return (
        <>
            <Modal
                show={showModal}
                size="sm"
                className="custom-modal blur-bg"
                centered
            >
                <Modal.Header>
                    <div className="border-0 pb-0 d-flex justify-content-between w-100">
                        <h6 className="modal-title text-blue-900">Notification Filter</h6>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setShowModal(false);
                                manuplateAllItems(false);
                            }}
                        ></button>
                    </div>
                </Modal.Header>
                <Modal.Body className='py-1 px-4'>
                    <div className="mb-3">
                        <ul
                            className='list-unstyled border rounded-3 overflow-auto'
                            style={{ height: '280px' }}
                        >
                            <li
                                className={'border-top p-2 ps-6'}
                                key={Math.floor(Math.random() * 1000)}
                            >
                                <div className="form-check mb-0">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="flexRadioDefault"
                                        checked={
                                            allCategoryData?.length > 0 &&
                                            allCategoryData.every((item) => item?.isChecked)
                                        }
                                        onChange={(e) => manuplateAllItems(e.target.checked)}
                                        id="allCategory"
                                    />
                                    <label
                                        className="form-check-label d-inline-flex align-items-center text-dark"
                                        htmlFor="allCategory"
                                    >
                                        All Categories
                                    </label>
                                </div>
                            </li>
                            {
                                allCategoryData?.map((item) => {
                                    return (
                                        <li className={'border-top p-2 ps-6'} key={item?.ID}>
                                            <div className="form-check mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="flexRadioDefault"
                                                    id={item?.ID}
                                                    value={item?.ID}
                                                    checked={item?.isChecked}
                                                    onChange={(e) => handleInputChange(e, item?.ID)}
                                                />
                                                <label
                                                    className="form-check-label d-inline-flex align-items-center text-dark"
                                                    htmlFor={item?.ID}
                                                >
                                                    {item?.name}
                                                </label>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className="grid gap-3">
                            <button
                                className="btn btn-outline-primary g-col-6"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => manuplateAllItems(false)}
                                disabled={loader}
                            >
                                <span className="btn-upper-case">Clear All</span>
                            </button>
                            <button
                                className="btn btn-primary g-col-6"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => handleFilterSaveBtn()}
                                disabled={loader}
                            >
                                <span className="btn-upper-case">Save</span>
                            </button>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default NotificationFilterV1